import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme } from "../../../../hooks";
import { ReferralService } from "../../../../services";

const regionsData = [
  {
    label: "Greater Accra Region",
    cities: [
      { label: "Accra Central", value: 0 },
      { label: "Accra Mall", value: 1 },
      { label: "Achimota", value: 2 },
      { label: "Akweteyman", value: 3 },
      { label: "Ashaiman", value: 4 },
      { label: "Circle", value: 5 },
      { label: "Dansoman", value: 6 },
      { label: "Darkuman", value: 7 },
      { label: "East Legon", value: 8 },
      { label: "Graphic Road", value: 9 },
      { label: "Haatso", value: 10 },
      { label: "Junction Mall", value: 11 },
      { label: "Madina", value: 12 },
      { label: "McCarthy", value: 13 },
      { label: "NIA", value: 14 },
      { label: "Osu", value: 15 },
      { label: "Roman Ridge", value: 16 },
      { label: "Social Welfare", value: 17 },
      { label: "Spintex", value: 18 },
      { label: "Tema 1", value: 19 },
      { label: "Tema 25", value: 20 },
      { label: "Tema 6", value: 21 },
      { label: "Tesano", value: 22 },
      { label: "Teshie", value: 23 },
      { label: "Tudu", value: 24 },
      { label: "Westhills", value: 25 },
    ],
  },
  {
    label: "Ashanti Region",
    cities: [
      { label: "Abuakwa", value: 0 },
      { label: "Adum", value: 1 },
      { label: "Atonsu", value: 2 },
      { label: "Ayigya", value: 3 },
      { label: "Bantama", value: 4 },
      { label: "Kejetia", value: 5 },
      { label: "KNUST", value: 6 },
      { label: "Kumasi City Mall", value: 7 },
      { label: "Konongo", value: 8 },
      { label: "Mampong", value: 9 },
      { label: "Nhyiaeso", value: 10 },
      { label: "Obuasi", value: 11 },
      { label: "Suame", value: 12 },
      { label: "Tafo", value: 13 },
    ],
  },
  {
    label: "Western Region",
    cities: [
      { label: "Takoradi Main", value: 0 },
      { label: "Takoradi MC", value: 1 },
      { label: "Tarkwa", value: 2 },
      { label: "Bibiani", value: 3 },
    ],
  },
  {
    label: "Central Region",
    cities: [
      { label: "Cape Coast Abura", value: 0 },
      { label: "Cape Coast", value: 1 },
      { label: "Kasoa", value: 2 },
      { label: "Winneba", value: 3 },
    ],
  },
  {
    label: "Eastern Region",
    cities: [
      { label: "Donkorkrom", value: 0 },
      { label: "Koforidua", value: 1 },
      { label: "New Abirem", value: 2 },
    ],
  },
  {
    label: "Brong Ahafo Region",
    cities: [
      { label: "Goaso", value: 0 },
      { label: "Sunyani", value: 1 },
    ],
  },
  {
    label: "Volta Region",
    cities: [
      { label: "Atimpoku", value: 0 },
      { label: "Ho", value: 1 },
    ],
  },
  { label: "Northern Region", cities: [{ label: "Tamale", value: 0 }] },
  { label: "Upper East Region", cities: [{ label: "Bolgatanga", value: 0 }] },
  { label: "Upper West Region", cities: [{ label: "Wa", value: 0 }] },
];

const checkValidQuantity = (qty) => {
  if (!qty || isNaN(qty) || parseFloat(qty) - parseInt(qty) !== 0 || qty < 1)
    return false;
  return true;
};

const useReferralWinPickup = () => {
  const { themeContext, theme } = useTheme();
  const { userPoints } =
    useLoyalty();

  const regionFmt = regionsData.map(({ label: region }) => ({
    label: region,
    value: region,
  }));

  const [showAlert, setShowAlert] = useState(false);
  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const [quantity, setQuantity] = useState(1);
  const [region, setRegion] = useState();
  const [officeLocation, setOfficeLocation] = useState();
  const [officeLocations, setOfficeLocations] = useState([]);
  const [isValidQuantity, setIsValidQuantity] = useState(false);
  const [updatedUserPoints, setUpdatedUserPoints] = useState(0);
  const [itemCode, setItemCode] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [redeemedId, setRedeemedId] = useState(null);

  useEffect(() => {
    setOfficeLocation(null);
    if (region) {
      const foundOfficeLocations = regionsData.find(
        ({ label }) => label === region
      );
      if (foundOfficeLocations) {
        setOfficeLocations(
          foundOfficeLocations.cities.map(({ label }) => ({
            label,
            value: label,
          }))
        );
      }
    } else {
      setOfficeLocations([]);
    }
  }, [region]);

  useEffect(() => {
    const isValidQty = checkValidQuantity(quantity);
    setIsValidQuantity(isValidQty);
    if (isValidQty) {
      setUpdatedUserPoints(userPoints - quantity * 2500);
    }
  }, [quantity]);

  const handleSubmit = () => {
    setLoading(true);
    setError(null);
    const order = {
      quantity,
      region,
      officeLocation,
      itemCode,
    }
    const token = JSON.parse(localStorage.getItem("token"));
    ReferralService.redeemReward(token, order)
    .then((data) => {
      if (data) {
        setRedeemedId(data._id);
        console.log(data);
      }
    })
    .catch((error) => {
      console.log(error);
      setError(error);
    })
    .finally(() => {
      setLoading(false);
      setShowAlert(true);
    });
  }

  return {
    background,
    history,
    regionFmt,
    showAlert,
    setShowAlert,
    quantity,
    setQuantity,
    region,
    setRegion,
    officeLocation,
    setOfficeLocation,
    officeLocations,
    setOfficeLocations,
    isValidQuantity,
    setIsValidQuantity,
    handleSubmit,
    updatedUserPoints,
    unitPoints: 50,
    itemCode,
    setItemCode,
    error,
    loading,
    redeemedId,
  };
};

export default useReferralWinPickup;
